




import OnsiteSearch from './components/OnsiteSearch.vue'

export default {
  name: 'OnsiteSearchApp',
  components: {
    OnsiteSearch
  }
}
